import { useState, useEffect, Suspense, useRef, useCallback, useContext } from "react";
import { Paginator } from "primereact/paginator";
import { ClientsList, SendClientEmail } from "./Service/TaskService.js";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions.js";
import { ProjectModalContext } from "./Service/ProjectModalContext.jsx";
import { TostMsg } from "../../../App.js";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices.js";
import { MultiSelect } from "primereact/multiselect";

const ClientList = () => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");
  const searchDebounceRef = useRef();
  const [allClients, setClientList] = useState([]);
  const [clientSummary, setClientSummary] = useState({});
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const { openAddClient, registerClientSaveCallback } = useContext(ProjectModalContext);
  let userPermissions = getRawPermissionsArray();
  const [clientCreate, setClientCreate] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const history = useHistory();
  const toster = useContext(TostMsg);
  const [isEmailModal, setIsEmailModal] = useState(false);
  const [currentClient, setCurrentClient] = useState(null);
  const isInitialMount = useRef(true);
  const [filterOpen, setFilterOpen] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedtStatus, setSelectedtStatus] = useState("");
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [selectedProjectCount, setSelectedProjectCount] = useState("");


  const toggleSortOrder = () =>
    setSortOrder((prev) => (prev === "ASC" ? "DESC" : "ASC"));

  const SORT_OPTIONS = [
    { label: "Modified On(Default)", value: "" },
    { label: "Company Name", value: "Company Name" },
    { label: "Contact Person", value: "Contact Person" },
    { label: "Country", value: "Country" },
    { label: "Project Count", value: "Project Count" },

  ];


  useEffect(() => {
    getClientList(1, rows, searchText);
    setFirst(0);
  }, [selectedCountry, selectedtStatus, sortBy, sortOrder, selectedProjectCount]);


  const renderToggleArrow = (isOpen, color = "currentColor") => (
    <svg viewBox="0 0 20 20" width="18" height="18" xmlns="http://www.w3.org/2000/svg" fill="none" style={{ display: "block" }}>
      <path
        d={isOpen ? "M5 12l5-5 5 5" : "M5 7l5 5 5-5"}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );


  const toggleSection = (section) => {
    if (section === "filter") setFilterOpen(!filterOpen);
    else if (section === "summary") setSummaryOpen(!summaryOpen);
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false; // skip on mount, mark as done
      return;
    }
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      getClientList(1, rows, searchText);
      setFirst(0);
    }, 400);
    return () => clearTimeout(searchDebounceRef.current);
    // eslint-disable-next-line
  }, [searchText]);

  // 3. Keep your original mount useEffect exactly as is:
  useEffect(() => {
    getClientList(1, rows, searchText);
    permissionList();
    GetMasterSystemAlertList("Client_Summary", 2);
    getCountryList();
  }, []);

  useEffect(() => {
    registerClientSaveCallback(() => getClientList(1, rows, searchText));
  }, [registerClientSaveCallback, rows, searchText]);



  const GetMasterSystemAlertList = useCallback(async (message) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);



  const permissionList = () => {
    if (userPermissions) {
      userPermissions?.map((UserPermission) => {
        if (UserPermission?.PermissionName == "Client.Create") {
          setClientCreate(true);
        }
      })
    }
  }



  async function getClientList(page = 1, pageSize = rows, search = "") {
    const params = {
      Id: 0,
      Guid: "",
      Search: search,
      PageNumber: page,
      PageSize: pageSize,
      CountryId: selectedCountry?.length
        ? selectedCountry.join(",")
        : "",
      TotalProjects: Number(selectedProjectCount) || 0,
      Status: Number(selectedtStatus) || 0,
      SortBy: sortBy || "",
      SortOrder: sortOrder || "ASC"
    };

    setIsloading(true);
    try {
      const response = await ClientsList(params);
      setClientList(response?.Data);
      setTotalRecords(
        response?.Data[0]?.TotalClients || response?.Data?.length || 0
      );
    } catch (error) {
      toster.current.error(
        error.response?.Data?.Message || "Something went wrong"
      );
    } finally {
      setIsloading(false);
    }
  }


  // Render Summary Strip
  const renderSummary = () => {
    const total = clientSummary.TotalClients || 0;
    const active = clientSummary.ActiveClients || 0;
    const archived = clientSummary.ArchivedClients || 0;
    const publicClients = clientSummary.PublicClients || 0;
    const privateClients = clientSummary.PrivateClients || 0;

    return (
      <>
        <div className="sc r">
          <div className="sc-lab">Total</div>
          <div className="sc-val">{total}</div>
        </div>
        <div className="sc g">
          <div className="sc-lab">Active</div>
          <div className="sc-val">{active}</div>
        </div>
        <div className="sc gr">
          <div className="sc-lab">Archived</div>
          <div className="sc-val">{archived}</div>
        </div>
        <div className="sc gr">
          <div className="sc-lab">Public</div>
          <div className="sc-val">{publicClients}</div>
        </div>
        <div className="sc gr">
          <div className="sc-lab">Private</div>
          <div className="sc-val">{privateClients}</div>
        </div>
      </>
    );
  };


  const handleSearchChange = (value) => {
    setSearchText(value);
    // Debounce will handle API call
  };

  const onPageChange = (event) => {
    const page = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getClientList(page, event.rows, searchText);
  };

  async function sendEmailToClient() {
    const params = {
      clientId: currentClient?.Id,
    };
    setIsloading(true);
    try {
      const response = await SendClientEmail(params);
      setIsEmailModal(false);
      toster.current.success(
        response?.Message
      );
    } catch (error) {
      toster.current.error(
        error?.response?.Message || "Something went wrong"
      );
    } finally {
      setIsloading(false);
    }
  }

  const getCountryList = async () => {
    try {
      const params = {
        organisationId: userDetails?.OrgId,
        masterType: "Countries",
      };

      const response = await GetMasterTypeData(params);

      setCountryList(response?.Data || []);
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  };





  const clearFilters = () => {
    setSearchText("");
    setSelectedCountry([]);
    setSelectedtStatus([]);
    setSelectedProjectCount("")
    setSortBy("");
    setSortOrder("ASC");
    setFirst(0);
  };


  const hasActiveFilters =
    searchText ||
    selectedCountry?.length > 0 ||
    selectedtStatus?.length > 0 ||
    selectedProjectCount?.length > 0 ||
    sortBy;


  return (
    <div className="">
      <div className="task-top-pane">
        <i class="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>
      <div className="tm-main-area">
        <div className="page-head">
          <div>
            <h2 className="client-title">Clients
              <p className="topbar-sub" id="clientCount">
                <>
                  ({totalRecords || 0})
                  {/* {totalRecords > 1 ? "clients" : "client"} */}
                </>
              </p></h2>
            <p className="topbar-sub" id="clientCount">
              <>
                Active: {allClients[0]?.ActiveClients || 0}{" "}
                InActive: {allClients[0]?.InActiveClients || 0}{" "}
              </>
            </p>

            {/* <div className="topbar-sub" id="clientCount">
              <>
                {masterSystemAlertData}
              </>
            </div> */}

          </div>
          <div className="d-flex" style={{ gap: "9px" }}>
         
            {clientCreate && (
              <div className="head-actions">
                <button
                  className="btn btn-brand btn-sm"
                  onClick={() => openAddClient()}
                >
                  <i className="fa-solid fa-plus"></i> New Client
                </button>
              </div>
            )}
          </div>

        </div>
        <div className="page">

          <div className="collapsible-section" id="filterSection" onClick={() => toggleSection("filter")}>
            <div className="section-toggle">
              <div className="section-toggle-icon icon-filter">
                <svg viewBox="0 0 28 28" width="28" height="28" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <rect width="28" height="28" rx="8" fill="#f0fdf4" />
                  <path d="M7 9.5h14M9.5 14h9M12 18.5h4" stroke="#15803d" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </div>
              <span className="section-label" onClick={() => toggleSection("filter")}>Filters</span>
              <div className={`section-toggle-arrow ${filterOpen ? "open" : ""}`} id="filterChevron" style={{ color: "#15803d" }}>
                <div className="sort-bydiv" onClick={(e) => e.stopPropagation()}>
                  {/* ── Sort By dropdown ── */}
                  <label style={{ fontSize: "11px", color: "var(--muted)", whiteSpace: "nowrap", marginBottom: "0" }}>Sort By:</label>
                  <select
                    className="fs"
                    style={{ width: "auto" }}
                    value={sortBy}
                    onChange={(e) => { setSortBy(e.target.value); setSortOrder("ASC"); }}
                  >
                    {SORT_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  {/* ── ASC / DESC toggle button ── */}
                  <button
                    type="button"
                    className="btn btn-ghost btn-icon btn-sm"
                    title={sortOrder === "ASC" ? "Ascending — click for Descending" : "Descending — click for Ascending"}
                    onClick={toggleSortOrder}
                    disabled={!sortBy}
                    style={{
                      opacity: sortBy ? 1 : 0.35,
                      cursor: sortBy ? "pointer" : "not-allowed",
                      fontSize: "13px",
                      width: "30px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid var(--border)",
                      borderRadius: "var(--radius)",
                      background: sortBy ? "var(--card)" : "transparent",
                      transition: "all 0.15s",
                    }}
                  >
                    {sortOrder === "ASC"
                      ? <i className="fa-solid fa-arrow-up-a-z"></i>
                      : <i className="fa-solid fa-arrow-down-z-a"></i>}
                  </button>
                </div>
                {renderToggleArrow(filterOpen, "#15803d")}

              </div>
            </div>

            <div className={`section-body ${filterOpen ? "open" : ""}`} id="filterBody">
              <div className="section-body-inner" onClick={(e) => e.stopPropagation()}>
                <div
                  className="toolbar">

                  <div className="d-flex justify-content-between flex-wrap">
                    <div className="d-flex gap-2 align-items-center">
                      {/* Search */}
                      <div className="sw" style={{ flex: "2 1 220px", minWidth: 180 }}>
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                          className="si"
                          id="searchInp"
                          placeholder="Search projects…"
                          value={searchText}
                          onChange={(e) => handleSearchChange(e.target.value)}
                          style={{ width: "100%" }}
                        />
                      </div>

                      <div className="tsep"></div>

                      {/* Country — MultiSelect */}
                      <MultiSelect
                        value={selectedCountry}
                        onChange={(e) => setSelectedCountry(e.value)}
                        options={countryList}
                        optionLabel="Name"     // ✅ FIXED (was CountryName)
                        optionValue="Id"
                        placeholder="Select Country"
                        filter
                        style={{ flex: "1 1 140px", minWidth: 130 }}
                      />



                      {/* Project Count — MultiSelect */}
                      <select className="form-control"
                        value={selectedProjectCount}
                        onChange={(e) => setSelectedProjectCount(e.target.value)} style={{ flex: "1 1 130px", minWidth: 120 }}
                      >
                        <option value="">Clients With All Projects</option>
                        <option value={1}>Clients With Single Project</option>
                        <option value={2}>Clients With Two Projects</option>
                        <option value={3}>Clients With 3 To 5 Projects</option>
                        <option value={5}>Clients With 5 TO 10 Projects</option>
                        <option value={10}>Clients With 10 To More Projects</option>
                      </select>

                      {/* Status — MultiSelect */}
                      <select className="form-control"
                        value={selectedtStatus}
                        onChange={(e) => setSelectedtStatus(e.target.value)}
                        style={{ flex: "1 1 130px", minWidth: 120 }}
                      >
                        <option value="">All Status</option>
                        <option value={1}>Active</option>
                        <option value={2}>In-Active</option>
                      </select>



                      <div className="tsep"></div>


                    </div>
                    <button
                      className="btn btn-ghost btn-sm"
                      onClick={clearFilters}
                      disabled={!hasActiveFilters}
                      title="Clear all filters"
                      style={{
                        opacity: hasActiveFilters ? 1 : 0.4,
                        cursor: hasActiveFilters ? "pointer" : "not-allowed",
                      }}
                    >
                      <i className="fa-solid fa-xmark"></i> Clear
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>


          <div className="flex" style={{ flex: 1, overflow: "hidden" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowX: "scroll"

              }}
            >
              {/* Summary Strip */}
              {/* <div>
                <div className="sstrip" id="sumStrip">
                  {renderSummary()}
                </div>
              </div> */}

              {/* Toolbar */}
              {/* <div>
                <div
                  className="toolbar mb-3 "
                  style={{
                    borderRadius: "var(--radius-lg)",
                    border: "1px solid var(--border)",
                  }}
                >
                  <div className="sw">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input
                      className="si"
                      id="searchInp"
                      placeholder="Search clients…"
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e.target.value)}
                    />
                  </div>
                </div>
              </div> */}

              {/* Clients Table */}
              <div
                className="height-body-equal"
              >
                <table className="dtbl" id="clientTable">
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th>Company Contact</th>
                      <th>Primary Person</th>
                      <th>Primary Person Contact</th>
                      <th>Project'S</th>
                      <th>Active</th>
                      <th>Website</th>
                      <th>Address / Country</th>
                      {/* <th></th>
                      <th></th> */}

                      <th className="task-actions-header">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allClients?.length > 0 ? (
                      allClients?.map((c) => (
                        <tr
                          key={c?.Id}
                          onClick={() => window.open(`/Project/List/${c.Guid}`, "_blank")}
                          style={{ cursor: "pointer" }}
                        >

                          <td style={{ cursor: "pointer" }}
                          >
                            <div className="w-s" style={{ fontWeight: 600 }}>
                              {c.Name || c.ClientName || "N/A"}
                              {c.ClientId?.length > 0 && (
                                <code
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: 700,
                                    color: "var(--brand)",
                                  }}
                                >
                                  {c.ClientId}
                                </code>)}
                            </div>
                          </td>

                          <td style={{ fontSize: "11.5px" }}>
                            <b>{c.Phone || "N/A"} </b>
                            <p className="module-status"> {c.Email || "N/A"}</p>
                          </td>
                          <td style={{ fontSize: "11.5px" }}>
                            <b>  {c.PrimaryContact || "N/A"}</b>
                            <p className="module-status"> {c.PrimaryContactDesignation || "N/A"}</p>
                          </td>

                          <td style={{ fontSize: "11.5px", color: "var(--mid)" }}>
                            <b> {c.PrimaryContactPhone || "N/A"}</b>
                            <p className="module-status">  {c.PrimaryContactEmail || "N/A"}</p>
                          </td>
                          <td style={{ fontSize: "11.5px" }}>
                            {c?.TotalProjects > 0 ? c?.TotalProjects : 'N/A'}
                            {/* <i class="fa-solid fa-folder-open"></i>*/}
                          </td>
                          <td>
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "3px",
                                padding: "2px 7px",
                                borderRadius: "20px",
                                fontSize: "10.5px",
                                fontWeight: 500,
                                background: c?.ClientStatus == "Yes" ? "#dcfce7" : "#fee2e2",
                                color: c?.ClientStatus == "Yes" ? "#16a34a" : "#dc2626",
                              }}
                            >
                              {/* <span
                                style={{
                                  width: "4px",
                                  height: "4px",
                                  borderRadius: "50%",
                                  background: c?.ClientStatus == "Yes" ? "#16a34a" : "#dc2626",
                                  display: "inline-block",
                                }}
                              /> */}
                              {c?.ClientStatus == "Yes" ? "Yes" : "No"}
                            </span>
                          </td>
                          <td style={{ fontSize: "11.5px" }} onClick={(e) => e.stopPropagation()}>
                            {c.Website ? (
                              <a
                                href={c.Website.startsWith("http") ? c.Website : `https://${c.Website}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {c.Website}
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td
                            style={{ fontSize: "11.5px" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <p style={{
                              fontSize: "11.5px", margin: "0",
                              width: "130px", whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }} title={(c?.Address || c?.City || c?.State) ? `${c?.Address} ${c?.City} ${c?.State} ${c.Zip || "N/A"}` : "N/A"}>
                              {(c?.Address || c?.City || c?.State) ? (
                                <span>{c?.Address}{" "}{c?.City}{" "}{c?.State} {c.Zip || "N/A"}</span>
                              ) : (
                                <span>N/A</span>
                              )}
                            </p>
                            <div style={{ fontSize: "11.5px" }}>
                              {c.CountryName || "N/A"}
                            </div>
                          </td>
                          {/* <td >
                           
                          </td>
                          <td >
                            
                          </td> */}
                          <td className="task-actions-cell" onClick={(e) => e.stopPropagation()}>
                            <div className="flex gap4 task-actions">
                              {clientCreate && (
                                <button
                                  className="btn btn-ghost btn-icon"
                                  onClick={() => openAddClient(c)}
                                  title="Edit"
                                >
                                  <i className="fa-solid fa-pen"></i>
                                </button>
                              )}
                              {clientCreate && (
                                <button
                                  className="btn btn-ghost btn-icon"
                                  onClick={() => {
                                    setIsEmailModal(true);
                                    setCurrentClient(c);
                                  }}
                                  title="Send Email"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                                  </svg>
                                </button>
                              )}

                            </div>
                          </td>
                        </tr>
                      ))

                    ) : (
                      <tr>
                        <td colspan="15" style={{ "textAlign": "center" }}>No clients found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="sticky-footer">
                  <div className="card">
                    <Paginator
                      first={first}
                      rows={rows}
                      totalRecords={totalRecords}
                      rowsPerPageOptions={[50, 100, 200, 500]}
                      onPageChange={onPageChange}
                    />
                  </div>
                </div>
              </div>


              <div style={{ height: "14px" }}></div>
            </div>
          </div>
        </div>
      </div>

      {/* Email Confirmation */}
      {isEmailModal && (
        <div
          className="modal show"
          id="delete-task-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                  </svg>
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to send an email to this client?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setIsEmailModal(false);

                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => {

                    sendEmailToClient();
                    // Proceed with sending email
                  }}
                >
                  Send Email
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default ClientList;

